export const ProjectDocFolderSubTypes = {
  Standart: 1,
  Change: 2,
}
